import { MDBRow } from 'mdb-react-ui-kit'
// import React from 'react'
import { Outlet } from 'react-router'

export function MeetOurTeamContent() {

    return (
        <>
            <MDBRow className={'border border-0 border-danger'}>
                <Outlet />
            </MDBRow>
        </>
    )
}